export default __webpack_public_path__ + "static/media/logo.bc7f3641.png";